










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SettingInfo extends Vue {


  get selected() {
    console.log(this.$store.getters.getSettings);
    return Object.entries(this.$store.getters.getSettings);
  }


}
